/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { useCallback, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// utils
// material
import { Button, displayModal } from '@insticator/insticator-ui';
import Space from 'material/space/space'
// content
// styles
import injectSheet from "react-jss";
import styles from './migrationcomplete_styles';

/* ========== ~~~~~~~~~~ COMMENTING 2.0 MIGRATION COMPLETE ~~~~~~~~~~ ========== */
const MigrationComplete = injectSheet(styles)((props) => {
  const dispatch = useDispatch();

  const { onClose } = props

  const handleClose = () => {
    dispatch(displayModal(false))
    onClose?.()
  }

  return (
    <Space direction={'column'} alignItems={'center'} justifyContent={'center'}>
      <h4>Migration Complete!</h4>
      <Space direction={'column'} alignItems={'flex-start'} justifyContent={'flex-start'} gap={16} style={{textAlign: 'left',}}>
        <p>You have successfully migrated all comment and user data for this site to the new system!</p>
        <p><strong>All users should have access to their historical comments, reactions, and status ranks!</strong></p>
        <p>Please update the <strong>“Message to End-Users”</strong> section of the commenting configurations to reflect the completed status.</p>
      </Space>
      <Space style={{marginTop: '32px'}} alignItems={'center'} justifyContent={'center'}>
        <Button text={'Close'} variant='none' color='light' handleClick={handleClose} />
      </Space>   
    </Space>
  )
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default MigrationComplete